import { Dialog as MuiDialog, DialogProps as MuiDialogProps, styled } from "@mui/material";

const StyledDialog = styled(MuiDialog)(() => {
  return {
    borderRadius: "2.5rem",
  };
});

interface DialogProps extends MuiDialogProps {
  children: React.ReactNode;
}

export const Dialog: React.FC<DialogProps> = ({ children, ...props }) => {
  return <StyledDialog {...props}>{children}</StyledDialog>;
};

export default Dialog;
